/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withRouter } from 'react-router';
import { Query } from '@apollo/client/react/components';
import {
    string, shape, arrayOf, number, object, func,
} from 'prop-types';
import mbpLogger from '@module-logger/mbp';
import { getProductDetailBySKU } from '../../../../../../pages/Account/services/graphQL';
import { GRAPHQL_ENV } from '../../../../../../gql';
import GraphqlFoodQuickView from './GraphqlFoodQuickView';
import QuickViewLinkSkeleton from '../../../../GraphqlSkeletonComponents/QuickViewLinkSkeleton';

const GraphqlFoodQuickViewContainer = ({
    product,
    selectedSku,
    location,
    productUrl,
    brand,
    renderSkuPrice,
    onClickTracking,
}) => {
    const domain = brand ? brand?.domain : null;
    const SKU = selectedSku ? selectedSku.id : null;
    const FIND_PDP_BY_PART = getProductDetailBySKU(SKU, domain, GRAPHQL_ENV);
    return (
        <Query query={FIND_PDP_BY_PART}>
            {({ loading, data, error }) => {
                if (loading) {
                    return <QuickViewLinkSkeleton />;
                }
                if (error) {
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        query: FIND_PDP_BY_PART,
                        component: 'GraphqlFoodQuickViewContainer.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }

                if (!data) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: FIND_PDP_BY_PART,
                        component: 'GraphqlFoodQuickViewContainer.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }

                return (
                    <>
                        <GraphqlFoodQuickView
                            quickViewData={data?.findProductByPartNumber}
                            product={product}
                            selectedSku={selectedSku}
                            location={location}
                            productUrl={productUrl}
                            brand={brand}
                            renderSkuPrice={renderSkuPrice}
                            onClickTracking={onClickTracking}
                        />
                    </>
                );
            }}
        </Query>
    );
};

GraphqlFoodQuickViewContainer.defaultProps = {
    onClickTracking: null,
};

GraphqlFoodQuickViewContainer.propTypes = {
    brand: object.isRequired,
    selectedSku: shape({
        id: string.isRequired,
        name: string.isRequired,
        prices: arrayOf(
            shape({
                type: string.isRequired,
                value: number.isRequired,
                __typename: string.isRequired,
            }),
        ).isRequired,
        __typename: string.isRequired,
    }).isRequired,
    product: shape({
        name: string.isRequired,
        partNumber: string.isRequired,
        shortDescription: string.isRequired,
        image: shape({
            name: string.isRequired,
            path: string.isRequired,
        }).isRequired,
        availability: shape({
            deliveryMessage: string.isRequired,
            productDeliveryType: string.isRequired,
        }).isRequired,
    }).isRequired,
    productUrl: string.isRequired,
    location: object.isRequired,
    renderSkuPrice: func.isRequired,
    onClickTracking: shape({
        eventCategory: string,
        eventAction: string,
        eventLabel: string,
    }),
};

export default withRouter((GraphqlFoodQuickViewContainer));
